import { permissionObj } from '../../../../../Helpers/permission';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import React from 'react';
import { useSelector } from 'react-redux';
import { ATTENDANCE_SUBVIEW_MODEL } from '../Model/Model';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param string - subView: sub-view type
 * @param event - changeSubViewManage: event to change the sub-view
 */
const SubViewOptions = (
    {
        subView,
        changeSubViewManage
    }
) => {

    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    return (
        <div className='d-flex gap-3'>
            {(DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_SHIFT_READ)) &&
                <ButtonAction
                    id='btn_svo_shift_access'
                    name='shift_access'
                    className={ATTENDANCE_SUBVIEW_MODEL.MANAGE.SHIFT_ACCESS === subView ? 'btn-outlined-secondary-600-100' : 'btn-outlined-secondary-600-00'}
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        changeSubViewManage(ATTENDANCE_SUBVIEW_MODEL.MANAGE.SHIFT_ACCESS);
                    }}
                />
            }

            {(DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_SETTING_READ)) &&
                <ButtonAction
                    id='btn_svo_settings'
                    name='settings'
                    className={ATTENDANCE_SUBVIEW_MODEL.MANAGE.SETTINGS === subView ? 'btn-outlined-secondary-600-100' : 'btn-outlined-secondary-600-00'}
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        changeSubViewManage(ATTENDANCE_SUBVIEW_MODEL.MANAGE.SETTINGS);
                    }}
                />
            }

            {(DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_DEPARTMENT_POLICIES_READ)) &&
                <ButtonAction
                    id='btn_svo_department_policies'
                    name='department_policies'
                    className={ATTENDANCE_SUBVIEW_MODEL.MANAGE.DEPARTMENT_POLICIES === subView ? 'btn-outlined-secondary-600-100' : 'btn-outlined-secondary-600-00'}
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        changeSubViewManage(ATTENDANCE_SUBVIEW_MODEL.MANAGE.DEPARTMENT_POLICIES);
                    }}
                />
            }

           {/* {(DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_READ)) &&
                <ButtonAction
                    id='btn_svo_geofences'
                    name='geofences'
                    className={ATTENDANCE_SUBVIEW_MODEL.MANAGE.GEOFENCE === subView ? 'btn-outlined-secondary-600-100' : 'btn-outlined-secondary-600-00'}
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        changeSubViewManage(ATTENDANCE_SUBVIEW_MODEL.MANAGE.GEOFENCE);
                    }}
                />
            }*/}
        </div>
    );

}

export default SubViewOptions
